var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"day-events"},[_c('v-row',[_c('span',{staticClass:"text-h5 ma-5 mb-1 ml-6"},[_vm._v("Добавить входящий звонок")])]),_c('Call')],1)}
var staticRenderFns = []

export { render, staticRenderFns }